import useMutation from "src/hooks/useMutation";

function useWTUpdateCode(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/transferDetailId/import`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTUpdateCode;
